var { DateTime } = require('luxon');

export const handleDateFormat = (epoch, format) => DateTime.fromSeconds(epoch).toFormat(format);